<template>
    <div class="topbar d-flex align-content-center flex-wrap">
        <b-alert class="alert"
            :show="dismissCountDown"
            dismissible
            variant="warning"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            >
            <p>Future Feature.</p>
            <hr>
            <p>This alert will dismiss after {{ dismissCountDown }} seconds...</p>
            <b-progress
                variant="warning"
                :max="dismissSecs"
                :value="dismissCountDown"
                height="10px"
            ></b-progress>
        </b-alert>
        <b-container fluid>
            <b-row>
                <b-col md="1" lg="2">
                    <a href="/" @click="home">
                        <b-img width="90px" src="https://i.imgur.com/aicQCL8.png" />
                    </a>
                </b-col>
                <b-col>
                    <Search/>
                </b-col>
                <b-col md="5" lg="4">
                    <div class="d-flex flex-row justify-content-end">
                        <div class="cta">
                            <b-dropdown text="For Businesses" variant="outline">
                                <b-dropdown-item @click="newBusiness">Add a new business</b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="cta">
                            <b-button 
                                variant="outline"
                                @click="clicked"
                            >
                                Write Review
                            </b-button>
                        </div>
                        <div class="cta" v-if="!isLoggedin">
                            <b-button 
                                variant="outline-primary"
                                @click="login"
                            >
                                Log In
                            </b-button>
                        </div>
                        <div class="cta" v-if="!isLoggedin">
                            <b-button 
                                variant="primary"
                                @click="signup"
                            >
                                Sign Up
                            </b-button>
                        </div>
                        <div v-if="isLoggedin">
                            <b-dropdown variant="outline" right no-caret>
                                <template slot="button-content">
                                    <img src="http://cdn.onlinewebfonts.com/svg/img_568656.png" width="30" alt="Left image" />
                                </template>
                                <b-dropdown-item href="#"> <b-icon icon="person-circle" font-scale="1.00"></b-icon> About Me</b-dropdown-item>
                                <b-dropdown-item href="#"> <b-icon icon="gear" font-scale="1.00"></b-icon> Account Settings</b-dropdown-item>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item @click="logout"> <b-icon icon="arrow-right-circle" font-scale="1.00"></b-icon> Log Out</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.topbar {
    background-color: white;
    height: 13vh;
    z-index: 501;
}

.cta {
    /* position: absolute; */
    /* top: 10%; */
    /* right: 5%; */
    margin: 5px;
    white-space: nowrap;
}

.alert {
    z-index: 501;
    position: absolute;
    width: 98%;
}

</style>

<script>
import Vue from 'vue'
import Search from '../search/Search'
import jwt_decode from "jwt-decode"

export default {
    components: {
        Search
    },
    data() {
        return {
            dismissSecs: 10,
            dismissCountDown: 0,
            showDismissibleAlert: false
        }
    },
    methods: {
        clicked() {
            console.log('clicked')
            //this.showAlert()
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },
        login() {
            console.log('login clicked')
            this.$keycloak.login()
        },
        signup() {
            console.log('signup clicked')
            this.$keycloak.register()
        },
        logout() {
            console.log('logout clicked')
            this.$router.push({
                name: 'Home',
                params: {}
            })
            this.$keycloak.logout()
        },
        home() {
            console.log('home clicked')
            // force redirect for mounted vue to retrigger again (based on href above)
        },
        newBusiness() {
            console.log('new business')
            // change the url but dont refresh / trigger
            // this is done so redirect_uri is captured when trying
            // to login in keycloak under AddNewBusiness before route
            history.pushState(
                {},
                null,
                this.$route.path + 'newbusiness'
            )
            this.$router.push({
                name: 'AddNewBusiness',
                params: {}
            })
        }
    },
    computed: {
        isLoggedin: {
            get() {
                return this.$keycloak.authenticated
            }
        }
    },
    mounted() {
        this.$root.$on('showFutureFeature', () => {
            this.dismissCountDown = 10
        })

        var decoded = jwt_decode(Vue.prototype.$getAccessToken())
        console.log('user_id is: '+decoded.sub)
        this.$store.dispatch('setAuthUserId', decoded.sub)
        this.$store.dispatch('setAuthSessionId', decoded.session_state)
    }
}
</script>